export enum MessageStatuses {
  'initial',
  'verify',
  'error',
  'success',
  'loading',
}
